import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ThankYouPage from './pages/ThankYouPage';
import BlogPage from './pages/BlogPage';
import ValuationPage from './pages/ValuationPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/valuation" element={<ValuationPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;